import './image-area.scss'

export function ImageArea({heatmapOriginal, heatmapSynthetic}) {
    return (
        <div className="image-area container">
            <img className="original" src={`data:image/png;base64,${heatmapOriginal}`} alt="original heatmap" />
            <img className="synthetic" src={`data:image/png;base64,${heatmapSynthetic}`} alt="synthetic heatmap" />
        </div>
    )
}